import { Button } from "reactstrap";
import React, {
    useState,
    useRef
} from "react";
import {
    Input,
    Label,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { createProductConfig } from "../../../store/slices/productConfigSlice";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "axios";
import { use } from "i18next";

const AddCollection = ({ collections }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const client = useSelector((state) => state.clients?.selectedClient?.value);
    const [formFields, setFormFields] = useState({
        name: "",
        slug: "",
        description: ""
    });

    const {
        register,
        trigger,
        control,
        formState: { errors },
        setValue,
        reset
    } = useForm({
        defaultValues: {
            name: "",
            slug: "",
            description: ""
        }
    });

    const handleInput = (event, field) => {
        let value;
        value = event.target.value;
        setValue(field, value);
        setFormFields({ ...formFields, [field]: value });
    };

    const handleSubmitProducts = async () => {
        let isValid = await trigger();
        if (isValid) {
            const response = await dispatch(createProductConfig({
                ...formFields,
            }));
            if (response.payload) {
                toast.success("Collection added successfully");
                reset();
                setFormFields({
                    name: "",
                    slug: "",
                    description: ""
                });
                setValue("name", "");
                setValue("slug", "");
                setValue("description", "");
                navigate("/pages/prodcuts-collections");
            }
        }
    }
    React.useEffect(() => {
        if (formFields.name) {
            let slug = formFields.name.replace(/\s+/g, '_').toLowerCase();
            setFormFields({ ...formFields, slug: slug });
            setValue('slug', slug);
        }
    }, [formFields.name])

    return (
    <div className="card shadow-sm mt-4">
      <div className="card-body">
        <div className="mb-4">
          <Label>
            Name<span className="text-danger">*</span>
          </Label>
          <Input
            className="form-control digits"
            value={formFields.name}
            {...register("name", { required: "This field is required" })}
            onChange={(event) => handleInput(event, "name")}
          />
          {errors?.name && (
            <span className="mt-1 text-danger">{errors.name.message}</span>
          )}
        </div>

        <div className="mb-4">
          <Label>
            Description<span className="text-danger">*</span>
          </Label>
          <Input
            type="textarea"
            className="form-control digits"
            value={formFields.description}
            rows={4}
            {...register("description", { required: "This field is required" })}
            onChange={(event) => handleInput(event, "description")}
          />
          {errors?.description && (
            <span className="mt-1 text-danger">
              {errors.description.message}
            </span>
          )}
        </div>

        {/* Center aligned button */}
        <div className="d-flex justify-content-center">
          <Button color="primary" onClick={handleSubmitProducts}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddCollection;
